var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 1.25C7.75 0.834375 7.41563 0.5 7 0.5C6.58437 0.5 6.25 0.834375 6.25 1.25V6.25H1.25C0.834375 6.25 0.5 6.58437 0.5 7C0.5 7.41563 0.834375 7.75 1.25 7.75H6.25V12.75C6.25 13.1656 6.58437 13.5 7 13.5C7.41563 13.5 7.75 13.1656 7.75 12.75V7.75H12.75C13.1656 7.75 13.5 7.41563 13.5 7C13.5 6.58437 13.1656 6.25 12.75 6.25H7.75V1.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.c7736492871c6778274fa26b55fb79c0.svg";
export { ForwardRef as ReactComponent };